import CustomInput from "Common/CustomInput/CustomInput"
import CustomSelect from "Common/CustomSelect"
import CustomTextarea from "Common/CustomTextArea"
import ReactPortal from "Components/ReactPortal/ReactPortal"
import api from "http"
import { useEffect, useState } from "react"
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage"
import WriteOffServicelines from "./WriteOffServicelines"
import Validator, { ValidationTypes as V_Type, } from 'react-form-supervalidator';
import { amountGreaterThanBalanceValidator, isNullValidator } from "Utils/validators"
import Show from "Components/Show/Show"
import { LuX } from "react-icons/lu"
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew"
import NumberConversion from "Utils/NumberConversion"
import Skeleton from "Components/skeleton/Skeleton"
import { toast } from "react-toastify"
import FullPageLoader from "Components/FullPageLoader/FullPageLoader"
import { useSelector } from "react-redux"
import { GoInfo } from "react-icons/go";

const CreateWriteOffPopup = ({ onClose, disableDraggable, row }) => {
    const UNIQUE_ID = "CreateWriteOffPopup"
    const [serviceLines, setServiceLines] = useState([])
    const [writeOffModel, setWriteOffModel] = useState(
        {
            "patientId": row.patientId,
            "visitId": row.visitId,
            "paymentSource": "",
            "paymentType": "",
            "writeOffCode": "",
            "notes": "",
            "visitChargeWriteOff": [],
            writeOffDate: new Date().toISOString().split('T')[0]
        }
    )
    const [serviceLinesError, setServiceLinesError] = useState([])
    const [validationModel, setValidationModel] = useState({
        responsiblePartyError: null,
        writeOffCodeError: null,
        writeOffDateError: null,
    })
    const [visitPlanOptions, setVisitPlanOptions] = useState([])
    const [totalAdjustedAmount, setTotalAdjustedAmount] = useState(0)
    const [remainingClaimBalance, setRemainingClaimBalance] = useState(0)
    const [initialLoader, setInitialLoader] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filteredWriteOffCodes, setFilteredWriteOffCodes] = useState([])
    const [saveWriteoffResponseMessage, setSaveWriteoffResponseMessage] = useState("")
    const findWriteOffCodes = useSelector((state) => state.dataSlice.FindWriteOffCodes)
    const handleresponsiblePartyChange = async (e) => {
        let planType = "";
        let paymentSource = e.target.value;
        if (e.target.value === "Insurance") {
            try {
                setLoading(true)
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisitplanOptions/${row.visitId}`);
                setVisitPlanOptions(response.data.dataModel)
                planType = response.data.dataModel[0].value

                const filteredWriteOffCodes = findWriteOffCodes.filter((option) => option.isInsuranceWriteOff)
                setFilteredWriteOffCodes(filteredWriteOffCodes)
                setWriteOffModel((prev) => ({
                    ...prev,
                    paymentSource: paymentSource,
                    paymentType: planType,

                }))
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setLoading(false)
            }
        }
        else if (e.target.value === "Patient") {
            const filteredWriteOffCodes = findWriteOffCodes.filter((option) => option.isPatientWriteOff)
            setFilteredWriteOffCodes(filteredWriteOffCodes)
            setWriteOffModel((prev) => ({
                ...prev,
                paymentSource: paymentSource,
                paymentType: planType,

            }))
            setVisitPlanOptions([])
        }
        else {
            setVisitPlanOptions([])
            planType = ""
            setWriteOffModel((prev) => ({
                ...prev,
                paymentSource: paymentSource,
                paymentType: planType,
                writeOffCode: "",
            }))
            setFilteredWriteOffCodes([])
        }
    }
    const handleplanTypeChange = (e) => {
        setWriteOffModel((prev) => ({
            ...prev,
            paymentType: e.target.value,
        }))
    }

    const setValidation = () => {
        let validationArray = [];
        for (let index = 0; index < serviceLinesError.length; index++) {
            let myvalidationObject = {
                ...serviceLinesError[index],
                updatedAmountError: serviceLines[index].isChecked && serviceLines[index].chargeBalanceDue > 0 ? Validator(serviceLines[index].updatedAmount, [isNullValidator, (val) => amountGreaterThanBalanceValidator(val, serviceLines[index].chargeBalanceDue)], ['Amount is required', 'Amount cannot be greater than balance']) : null,
            };
            validationArray.push(myvalidationObject);
        }
        setServiceLinesError(validationArray);
        return Validator(validationArray, V_Type.NullCheck);
    }
    const setValidationModelError = () => {
        let validationObj = {
            ...validationModel,
            responsiblePartyError: Validator(writeOffModel.paymentSource, [V_Type.required], ['Responsible Party is required']),
            writeOffCodeError: Validator(writeOffModel.writeOffCode, [V_Type.required], ['Type is required']),
            writeOffDateError: Validator(writeOffModel.writeOffDate, [V_Type.required], ['Write Off Date is required']),
        }
        setValidationModel(validationObj);
        return Validator(validationObj, V_Type.NullCheck);
    }

    const handleBalanceChange = (visitChargeId, value) => {
        setServiceLines((prev) => prev.map((line) => line.visitChargeId === visitChargeId ? { ...line, updatedAmount: value } : line))
    }
    const handleCheckboxChange = (visitChargeId, isChecked) => {

        setServiceLines((prev) => prev.map((line) => line.visitChargeId === visitChargeId ? { ...line, isChecked: isChecked, updatedAmount: isChecked ? line.chargeBalanceDue : 0 } : line))
    }
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked
        setServiceLines((prev) => prev.map((line) => ({ ...line, isChecked: isChecked, updatedAmount: isChecked ? line.chargeBalanceDue : 0 })))
    }

    const handleCreateWriteOff = async () => {
        let myValidation = setValidation();
        let myValidationModel = setValidationModelError();
        if (myValidation || myValidationModel) {
        } else {
            try {
                setLoading(true)
                const payload = {
                    ...writeOffModel,
                    paymentSource: writeOffModel.paymentSource === 'Insurance' ? writeOffModel.paymentType : writeOffModel.paymentSource,
                    visitChargeWriteOff: serviceLines.filter((line) => line.isChecked && line.chargeBalanceDue > 0)// only those service lines which are checked and have balance due greater than 0
                }
                const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientPayment/AddClaimPatientWriteOff`, payload)
                toast.success(response.data.responseMessage)
                onClose()
            } catch (error) {
                // ErrorHandlingMessage(error)      
                setSaveWriteoffResponseMessage(error.response.data.responseMessage)
            } finally {
                setLoading(false)
            }
        }

    }
    useEffect(() => {
        // only those service lines which are checked
        const checkedServiceLines = serviceLines.filter((line) => line.isChecked)
        // sum of updatedAmount
        const total = checkedServiceLines.reduce((acc, line) => acc + (parseFloat(line.updatedAmount) || 0), 0)
        setTotalAdjustedAmount(total || 0)

        // Remaining claim balance = sum of chargeBalanceDue - sum of updatedAmount
        const remainingClaimBalanceAmount = checkedServiceLines.reduce((acc, line) => acc + parseFloat(line.chargeBalanceDue), 0) - total

        setRemainingClaimBalance(remainingClaimBalanceAmount || 0)
    }, [serviceLines])
    useEffect(() => {
        (async () => {
            try {
                setInitialLoader(true)
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisitChargeForWriteOff?visitId=${row.visitId}`);
                setServiceLines(response.data.dataModel.map((line) => ({
                    ...line,
                    isChecked: false,
                })))
                setServiceLinesError(response.data.dataModel.map((line) => ({

                    updatedAmountError: null
                })))
                if (row.isSelfPay) {
                    setWriteOffModel((prev) => ({
                        ...prev,
                        paymentSource: "Patient",
                        paymentType: "",
                    }))
                    const filteredWriteOffCodes = findWriteOffCodes.filter((option) => option.isPatientWriteOff)
                    setFilteredWriteOffCodes(filteredWriteOffCodes)
                }
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setInitialLoader(false)
            }
        })();
    }, [row, findWriteOffCodes])
    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            {loading && <FullPageLoader allowFullScreen />}
            <div className="fixed inset-0 z-10 flex items-center justify-center p-4 bg-black bg-opacity-50">
                <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                    <div className="sticky top-0 z-20 flex items-center justify-between px-6 py-4 bg-white border-b border-slate-200">
                        <h2 className="text-xl font-semibold text-slate-900">
                            Write-off Balance
                        </h2>
                        <button
                            onClick={() => onClose()}
                            className="transition-colors text-slate-400 hover:text-slate-600"
                        >
                            <LuX className="w-5 h-5" />
                        </button>
                    </div>

                    <div className="p-6 space-y-6">

                        <div className='grid grid-cols-12 gap-4'>
                            <div className={` ${visitPlanOptions.length > 0 ? 'col-span-6' : 'col-span-12'}`}>
                                <CustomSelect value={writeOffModel.paymentSource} onChange={handleresponsiblePartyChange} label="Responsible Party">
                                    <option value="">Select responsible party</option>
                                    <option value="Patient">Patient</option>

                                    {!row.isSelfPay && <option value="Insurance">Insurance</option>}
                                </CustomSelect>
                                {validationModel.responsiblePartyError}
                            </div>
                            <Show when={visitPlanOptions.length > 0}>
                                <div className="col-span-6">
                                    <CustomSelect value={writeOffModel.paymentType} onChange={handleplanTypeChange} label="Payer">
                                        {visitPlanOptions.map((option) => (
                                            <option title={option.label} key={option.id} value={option.value}>{option.label.length > 40 ? option.label.substring(0, 40) + '...' : option.label}</option>
                                        ))}
                                    </CustomSelect>
                                </div>
                            </Show>

                            <div className="col-span-12">
                                <CustomSelect value={writeOffModel.writeOffCode} label="Type" onChange={(e) => setWriteOffModel((prev) => ({ ...prev, writeOffCode: e.target.value }))}>
                                    <option value="">Please Select</option>
                                    {filteredWriteOffCodes.map((option) => (
                                        <option key={option.id} value={option.value}>{option.label}</option>
                                    ))}
                                </CustomSelect>
                                {validationModel.writeOffCodeError}
                            </div>
                            <div className="col-span-12">
                                <h1>Select Service lines</h1>
                                <Show when={!initialLoader} fallback={<Skeleton extraClass="h-40" />}>
                                    <WriteOffServicelines serviceLines={serviceLines} serviceLinesError={serviceLinesError} handleBalanceChange={handleBalanceChange} handleCheckboxChange={handleCheckboxChange} handleSelectAll={handleSelectAll} />
                                </Show>
                            </div>
                            <div className="col-span-6">
                                <CustomInput label="Total adjusted amount" disabled value={NumberConversion(totalAdjustedAmount)} />
                            </div>
                            <div className="col-span-6">
                                <CustomInput label="Remaining claim balance" disabled value={NumberConversion(remainingClaimBalance)} />
                            </div>
                            <div className="col-span-12">
                                <Show when={saveWriteoffResponseMessage}>
                                    <div className="flex items-start gap-2 p-3 mt-4 border-l-4 border-blue-300 rounded-lg bg-blue-50">
                                        <GoInfo size={18} color="#007bff" className="mt-0.5 flex-shrink-0" />
                                        <span className="mt-1 text-sm font-medium leading-tight text-blue-800">
                                            {saveWriteoffResponseMessage}
                                        </span>
                                    </div>
                                </Show>
                            </div>
                            <div className="col-span-12">
                                <CustomTextarea maxWidth="100%" label="Notes" value={writeOffModel.notes} onChange={(e) => setWriteOffModel((prev) => ({ ...prev, notes: e.target.value }))} />
                            </div>
                            <div className="col-span-12">
                                <CustomInput label="Date" type="date" value={writeOffModel.writeOffDate} onChange={(e) => setWriteOffModel((prev) => ({ ...prev, writeOffDate: e.target.value }))} />
                                {validationModel.writeOffDateError}
                            </div>
                        </div>
                        {/* Modal Footer */}
                        <div className="sticky bottom-0 z-[2] flex items-center justify-end gap-3 px-6 py-4 border-t bg-slate-50 border-slate-200">
                            <CustomButtonNew
                                label="Cancel"
                                variant="outline"
                                onClick={() => onClose()}
                            />
                            <CustomButtonNew
                                label="Create Write-Off"
                                onClick={handleCreateWriteOff}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ReactPortal>


    )
}

export default CreateWriteOffPopup